// use SVGs padding bottom hack for IE11
document.addEventListener("DOMContentLoaded", function() {
  if (!!window.MSInputMethodContext && !!document.documentMode) {
    var svgs = document.querySelectorAll(
      'svg[preserveAspectRatio="xMinYMin slice"]'
    );
    Array.prototype.forEach.call(svgs, function(el, i) {
      var viewBox = el.getAttribute("viewBox").split(" ");
      var width = viewBox[2];
      var height = viewBox[3];
      var ratio = ((Math.round(height) / Math.round(width)) * 100).toFixed(2);
      var paddingBottom = ratio.replace(".00", "") + "%";
      el.style.paddingBottom = paddingBottom;
      el.style.height = "1px";
      el.style.width = "100%";
      el.style.overflow = "visible";
    });
  }
});
